module.exports = __webpack_public_path__ + "static/media/family-law.1e1409b9.jpg";